import { useAuth } from "../utils/auth";
import { Navigate, useLocation } from "react-router-dom";

const RequireAARC = ({ children }) => {

    const auth = useAuth();
    const location = useLocation();

    if(!auth.user) {
        return <Navigate to='/aanmelden' state={{ path: location.pathname }} />
    } else if(auth.c === 129763 || auth.a === 157416 || auth.s === 185391 ) {
        return children;
    } else {
        return <Navigate to='/' state={{ path: location.pathname }} />
    }

}

export default RequireAARC;